export const getMyBetsAlias = (isSelfExcluded?: boolean, isEmbedded?: boolean) => {
  if (isEmbedded) {
    return 'sportsEmbeddedMyBets';
  } else if (isSelfExcluded) {
    return 'sportsSelfExcludedMyBets';
  }

  return 'sportsMyBets';
};
